import React from "react";
import pictures from "../assets/pictures.png";

const Trusted = () => {
  return (
    <div className="trusted position-relative">
      <div className="container">
        <div data-aos="fade-up" data-aos-anchor-placement="center-bottom">
          <h6 className="font-medium mb-1 text-center">WE ARE WEDEVELOPERS</h6>
          <p className="font-subhead font-weight-bolder text-center lh-small mb-25">
            Trusted software developers across <br /> 50+ countries
          </p>
          <p className="m-0 font-sm text-center">
            Most Innovative software development company providing top software
            development services. We serve both private and public sector;
            providing solutions to start-ups, software development companies,
            the world’s top companies and countless organisations.
          </p>
        </div>
        <div
          data-aos="zoom-in-up"
          data-aos-anchor-placement="center-bottom"
          data-aos-duration="1500"
          className="trustedimages position-relative my-2 d-flex justify-content-center">
          <img src={pictures} alt="trusted countries" />
        </div>
      </div>
    </div>
  );
};

export default Trusted;
